import React from 'react'
import {TextField, SimpleShowLayout, ReferenceField, DateField} from 'react-admin'
import { withStyles } from '@material-ui/core/styles'
import SegmentVersion from '../segmentsType/header/SegmentVersion'
import moment from "moment";
import Comments from "../../../elements/comments";
import AnswerChanges from "../segmentsType/history/AnswerChanges";
import SequenceChanges from "../segmentsType/history/SequenceChanges";
import {Link} from 'react-router-dom'
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";

const styles = {
  card: {
    width: '327px',
    backgroundColor: '#f8f8f8',
    alignSelf: 'flex-start',
    marginBottom: '20px'
  },
  columnLeft: {
    '&:first-child': {
      paddingTop: '0',
      paddingLeft: '0'
    }
  },
  segmentView: {
    width: '327px'
  },
  formInputField: {
    padding: "10px 0",
    borderBottom: "1px dashed rgba(0, 0, 0, 0.38)"
  },
  title: {
    marginBottom: '5px'
  },
  subHeader: {
    color: '#777'
  },
  subHeaderCorrect: {
    color: '#28a745'
  },
  groupContent: {
    backgroundColor: '#f5f5f5',
    padding: '15px',
    marginBottom: '15px',

    '& del': {
      backgroundColor: 'rgb(254, 221, 222)'
    },

    '& ins': {
      backgroundColor: 'rgb(230, 254, 207)',
      textDecoration: 'none'
    }
  },
  flexGroup: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between'
  },
  flexStart: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start'
  },
  textDanger: {
    color: '#b71c1c'
  },
  pdl: {
    paddingLeft: '10px'
  }
}

const changesHover = (node) => {
  const user = node.getAttribute('data-username')
  const changeUser = node.getAttribute('data-changedata')
  if (user != undefined) {
    const action = node.tagName === 'INS' ? 'Добавил(-а)' : 'Удалил(а)'
    node.setAttribute('title', action + ' ' + (user ? user : changeUser))
  }
}

const TestSegmentShow = ({ classes, record, permissions }) => (
  <>
    <SimpleShowLayout record={record} basePath="/archive">

      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div>
          {record.statusId !== 2 ? (
              <>
                <h2 className={classes.title}>Версия сегмента {record.originalId}</h2>
                <div className={classes.subHeader}>
                  Изменён {moment(record.createdAt).format('LLL')}. {record.author.surname} {record.author.name}
                </div>
              </>
          ) : (
              <>
                <h2 className={classes.title}>Сегмент {record.id} (в архиве)</h2>
              </>
          )}
        </div>
        { record.cloneSegment && (
            <Card className={classes.card}>
              <CardContent>
                <Typography variant="title" className={classes.title}>Информация о сегменте</Typography>
                <Typography>
                  На основе текущего создан: <Link to={{pathname: `/segments/${record.cloneSegment.id}`}}>{ record.cloneSegment.id }</Link>
                </Typography>
              </CardContent>
            </Card>
        ) }
      </div>

      <ReferenceField
        reference="test-types"
        source="typeId"
        linkType={false}
        label="Вид"
      >
        <TextField source="name" class={classes.formInputField} />
      </ReferenceField>

      <div className={classes.flexGroup}>
        <section>
          <SimpleShowLayout
            record={record}
            basePath="/archive"
            className={classes.columnLeft}
          >
            <TextField
              source="test.module.name"
              label="Модуль"
              class={classes.formInputField}
            />
            <TextField
              className={classes.textDanger}
              source="reasonDeactivated"
              label="Причина архивации"
            />
            <TextField
              source="test.programNumber.name"
              label="Номер вопроса программы"
              class={classes.formInputField}
            />
            <TextField
              source="test.source"
              label="Источник"
              class={classes.formInputField}
            />
            <DateField
              source="test.sourceDate"
              label="Дата редакции источника"
              class={classes.formInputField}
            />
            <TextField
              source="test.sourceLevel.name"
              label="Уровень владения источником"
              class={classes.formInputField}
            />
            <TextField
              source="test.number"
              label="Порядкой номер теста"
              class={classes.formInputField}
            />
            <TextField
              source="test.competence.number"
              label="Номер компетенции"
              class={classes.formInputField}
            />
            <TextField
              source="test.criteria.name"
              label="Тип теста"
              class={classes.formInputField}
            />
            <TextField
              source="test.program.name"
              label="Номер вопроса программы"
              class={classes.formInputField}
            />
            <TextField
              source="test.topic.name"
              label="Номер темы"
              class={classes.formInputField}
            />
          </SimpleShowLayout>
        </section>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <div className={classes.segmentView}>
            <SegmentVersion
              versions={record.versions}
              originalVersionId={record.originalId}
            />
          </div>
        </div>
      </div>

      <div className={classes.groupContent}>
        <div><small className={classes.subHeader}>Вопрос теста</small></div>
        <div
          dangerouslySetInnerHTML={{
            __html: record.test.question.content
          }}
          onMouseMove={(event) => {changesHover(event.target)}}
        />
        <Comments id={record.test.question.id} idType="testQuestionId" showAddBlock={false} originalComment={true} />
      </div>
      {record.test.question && record.test.answers.length > 0 && (
        record.test.answers.map(answer => (
          <div className={classes.groupContent}>
            <div className={classes.flexStart}>
              <div><small className={answer.correct ? classes.subHeaderCorrect : classes.subHeader}>Ответ №{answer.number}</small></div>
              {record.test.type.id != 5 && (
                  <>
                    {answer.authorCorrectChange && (
                        <AnswerChanges answer={answer} historyMode={true} />
                    )}
                  </>
              )}
              {record.test.type.id == 5 && (
                  <>
                    <div className={classes.pdl}><small className={classes.subHeaderCorrect}>Позиция {answer.correctPosition}</small></div>
                    <SequenceChanges answer={answer} historyMode={true} />
                  </>
              )}
            </div>
            <div
              dangerouslySetInnerHTML={{
                __html: answer.content
              }}
              onMouseMove={(event) => {changesHover(event.target)}}
            />
            <Comments id={answer.id} idType="answerId" showAddBlock={false} originalComment={true} />
          </div>
        )))}
      {record.test.questions && record.test.questions.map(question => (
        <SimpleShowLayout record={record} basePath="/archive">
          <div className={classes.groupContent}>
            <div><small className={classes.subHeader}>Подвопрос №{question.number}</small></div>
            <div
              dangerouslySetInnerHTML={{
                __html: question.content
              }}
              onMouseMove={(event) => {changesHover(event.target)}}
            />
            <Comments id={question.id} idType="questionId" showAddBlock={false} originalComment={true} />
          </div>
          {question.answers.map(answer => (
            <div className={classes.groupContent}>
              <div><small className={answer.correct ? classes.subHeaderCorrect : classes.subHeader}>Ответ №{answer.number}</small></div>
              <div
                dangerouslySetInnerHTML={{
                  __html: answer.content
                }}
                onMouseMove={(event) => {changesHover(event.target)}}
              />
              <Comments id={answer.id} idType="answerId" showAddBlock={false} originalComment={true} />
            </div>
          ))}
        </SimpleShowLayout>
      ))}
    </SimpleShowLayout>
  </>
)

export default withStyles(styles)(TestSegmentShow)
